<div style="display: block; position: relative;" [ngStyle]="{ 'width': width, 'height': height }">
  <canvas baseChart
    [data]="chartData"
    [options]="chartOptions"
    (chartClick)="chartClick($event)"
    [plugins]="barChartPlugins"
    [type]="chartType">
  </canvas>
</div>
